<template>
  <Transition name="modal">
    <div v-if="showModalMain" class="" id="modalPromoMain">
      <div class="modal-container">
        <div class="modal-header">
          <button class="close-black" @click="closeModalPromotionMain()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body">
          <a :href="link">
            <img
              :src="imageMain"
              alt="Promotional Banner"
              title="Promotional banner"
              :width="isMobile() ? 391 : 700"
              :height="isMobile() ? 378 : 677"
            />
          </a>
        </div>
      </div>
    </div>
  </Transition>

  <Transition
    name="footer"
    v-if="
      (!isMobile && props.optionsPromotionPopup.footer_banner != '') ||
      (isMobile && props.optionsPromotionPopup.side_banner != '')
    "
    id="modalPromoFooter"
  >
    <div v-if="showModalFooter" class="">
      <div class="modal-container-footer">
        <div class="modal-header-footer">
          <button class="close-black" @click="closeModalPromotionFooter()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body-footer">
          <a :href="link">
            <img
              :src="imageFooter"
              alt="Promotional Banner"
              title="Promotional banner"
              :width="isMobile() ? 391 : 1230"
              :height="isMobile() ? 48 : 150"
            />
          </a>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import { onBeforeMount, onMounted, ref } from 'vue'
  import { localeStore } from '../../stores/locale'
  import { promotionPopupStore } from '../../stores/promotionPopup'
  import { userStore } from '../../stores/user'
  import { isMobile } from '../../views/shared/utils/mobile'
  import { useCookies } from 'vue3-cookies'

  const storeLocale = localeStore()
  const storeUser = userStore()
  const storePromotionPopup = promotionPopupStore()

  const { cookies } = useCookies()

  const props = defineProps({
    optionsPromotionPopup: {
      type: Object,
      required: true
    }
  })

  const showModalMain = ref(false)
  const showModalFooter = ref(false)
  const imageMain = ref(
    'https://api.belladasemana.com.br/storage/promotions/' + props.optionsPromotionPopup.popup
  )
  const imageFooter = ref(
    'https://api.belladasemana.com.br/storage/promotions/' +
      (isMobile()
        ? props.optionsPromotionPopup.side_banner
        : props.optionsPromotionPopup.footer_banner)
  )
  const link = ref('/pt-br/assine')

  function linkPromotion() {
    if (props.optionsPromotionPopup.coupon != '')
      link.value = '/' + storeLocale.locale + '/assine?coupon=' + props.optionsPromotionPopup.coupon

    if (props.optionsPromotionPopup.voucher != '')
      link.value =
        '/' + storeLocale.locale + '/assine?voucher=' + props.optionsPromotionPopup.voucher

    if (props.optionsPromotionPopup.coupon == '' && props.optionsPromotionPopup.voucher == '')
      link.value = '/' + (storeLocale.locale ?? 'pt-br') + '/assine'

    link.value += '&acionador=ModalPromotionPopup'
  }
  function closeModalPromotionMain() {
    cookies.set('bellaPromoShow', '0', 1000 * 60 * 60 * 24)
    showModal()
    showModalMain.value = false
  }
  function closeModalPromotionFooter() {
    cookies.set('bellaPromoShow', '2', 1000 * 60 * 60 * 24)
    showModalFooter.value = false
  }
  function tryModalPromotion() {
    var bellaTimerPromotion = storePromotionPopup.bellaTimerPromotionPopup
    if (!bellaTimerPromotion.first_time_date) {
      var daysAccess = 1000 * 60 * 60 * 24 * 7 // 7 dias
      if (!cookies.isKey('countAccessPromotion')) {
        cookies.set('countAccessPromotion', '1', daysAccess)
      } else {
        if (parseInt(cookies.get('countAccessPromotion')) < 4) {
          cookies.set(
            'countAccessPromotion',
            String(parseInt(cookies.get('countAccessPromotion')) + 1),
            daysAccess
          )
        }
      }
      var params = {
        first_time_date: new Date().getTime()
      }
      storePromotionPopup.setPromotionParams(params)
      bellaTimerPromotion = storePromotionPopup.bellaTimerPromotionPopup
    }
    var timerParam = props.optionsPromotionPopup.banner_timer
    var timerPromo = parseInt(timerParam) * 1000
    if (timerPromo > 0) {
      if (!cookies.isKey('showFooterPromoBanner')) {
        var currentTimePromo = new Date().getTime()
        var diffPromo = currentTimePromo - Number(bellaTimerPromotion.first_time_date)
        var timeOutPromo = timerPromo - diffPromo < 0 ? 0 : timerPromo - diffPromo
        setTimeout(() => {
          if (storeUser.isActiveUser == false) {
            showModal()
          }
        }, timeOutPromo)
      }
    } else {
      if (storeUser.isActiveUser == false) {
        showModal()
      }
    }
  }
  function showModal() {
    if (cookies.get('bellaPromoShow') === '1') {
      if (props.optionsPromotionPopup.display != '') {
        var arrayDisplay = props.optionsPromotionPopup.display.toString()
        var arrayDisplay = arrayDisplay.split(',')
        if (arrayDisplay.includes(cookies.get('countAccessPromotion').toString())) {
          showModalMain.value =
            document.getElementById('modalSubscribeExit') == null &&
            document.getElementById('modalBannerPlanUnique') == null &&
            document.getElementById('modalLegalWarning') == null &&
            document.getElementById('modalNewsletter') == null
              ? true
              : false
        }
      }
    }
    if (!cookies.isKey('showFooterPromoBanner') && cookies.get('bellaPromoShow') === '0') {
      if (props.optionsPromotionPopup.footer_banner != '') {
        if (props.optionsPromotionPopup.display != '') {
          var arrayDisplay = props.optionsPromotionPopup.display.toString()
          var arrayDisplay = arrayDisplay.split(',')
          if (arrayDisplay.includes(cookies.get('countAccessPromotion').toString())) {
            showModalFooter.value =
              document.getElementById('modalSubscribeExit') == null &&
              document.getElementById('modalBannerPlanUnique') == null &&
              document.getElementById('modalLegalWarning') == null &&
              document.getElementById('modalNewsletter') == null
                ? true
                : false
          }
        }
      } else {
        cookies.set('showFooterPromoBanner', '0', 1000 * 60 * 60 * 7)
      }
    }

    if (showModalMain.value || showModalFooter.value) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'paywall',
        paywall: {
          acionador: 'ModalPromotionPopup'
        }
      })
    }
  }

  onBeforeMount(() => {
    tryModalPromotion()
  })

  onMounted(() => {
    if (props.optionsPromotionPopup) linkPromotion()
  })
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-mask-footer {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    position: fixed;
    z-index: 9998;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 700px;
    margin: auto;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }

  .modal-container-footer {
    z-index: 9999;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    opacity: 0.7;
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%);
  }
  .modal-header,
  .modal-header-footer {
    display: block;
    text-align: center;
  }

  .modal-body,
  .modal-body-footer {
    margin: 0;
    padding: 0px 0px;
  }

  .modal-default-button {
    float: right;
  }

  /*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

  .modal-enter-from {
    opacity: 0;
  }

  .modal-leave-to {
    opacity: 0;
  }

  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .close-black {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 1;
  }

  :deep(.modal-body img) {
    width: 100%;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .modal-container,
    .modal-container-footer {
      width: 95%;
    }

    :deep(.modal-body-footer img) {
      width: 100%;
      height: auto;
    }

    .close-modal {
      width: 35px;
      height: 35px;
      margin: 5px;
    }
  }
</style>
